module.exports = __webpack_public_path__ + "static/media/scale.e5aef706.svg";